module.exports = __webpack_public_path__ + "static/img/record.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/record.png
// module id = pg6L
// module chunks = 21